import { get, post, patch, del } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export interface GetSubContractorsParams {
  page?: number;
  limit?: number;
}

export const getSubContractors = (
  { page, limit }: GetSubContractorsParams = {},
  signal?: AbortSignal | null,
): Promise<ApiResponse> => {
  const query = new URLSearchParams();
  if (page  != null) query.set("page",  String(page));
  if (limit != null) query.set("limit", String(limit));
  return get(
    `${ENDPOINTS.SUB_CONTRACTORS.LIST}?${query.toString()}`,
    null,
    undefined,
    signal,
  );
};

export const createSubContractor = (data: unknown): Promise<ApiResponse> =>
  post(ENDPOINTS.SUB_CONTRACTORS.LIST, data);

export const updateSubContractor = (
  id: string,
  data: unknown,
): Promise<ApiResponse> => patch(ENDPOINTS.SUB_CONTRACTORS.UPDATE(id), data);

export const deleteSubContractor = (id: string): Promise<ApiResponse> =>
  del(ENDPOINTS.SUB_CONTRACTORS.DELETE(id));
